import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { formatCurrency } from 'utils';
import { SubsidyTableRow } from '../../types';

interface Props {
  rowIndex: number;
  subsidyPercent: number;
  dnetCoefficient: number;
}

export const ApprovedSubsidyCell = ({ rowIndex, subsidyPercent, dnetCoefficient }: Props) => {
  const { control } = useFormContext<ListingForm<SubsidyTableRow>>();
  const row = useWatch({ control, name: `bodyFields.${rowIndex}` });

  const approvedSubsidyAmount = useMemo(() => {
    const dnet = row?.dnet ?? 0;
    const financeAmount = row?.financeAmount ?? 0;
    const subsidyRate = subsidyPercent / 100;
    const cap = dnet * dnetCoefficient;

    return subsidyRate * Math.min(financeAmount, cap);
  }, [row?.dnet, row?.financeAmount, subsidyPercent, dnetCoefficient]);

  return <Typography fontWeight={500}>{formatCurrency(approvedSubsidyAmount, true)}</Typography>;
};
